import React, { useCallback, useState } from 'react';
import { bool, func, string } from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { CreateAListForm } from '@thd-olt-component-react/list-forms';
import { withOverlay } from '@thd-olt-component-react/component-design-patterns';
import styles from './create-button-desktop.module.scss';

export const CreateButtonDesktop = (props) => {
  const {
    className, dark, onCreate, outline, text, link, tag, transparent
  } = props;

  const handleCreate = (values) => {
    onCreate(values);
  };

  const CreateAListFormWithOverlay = withOverlay(
    CreateAListForm,
    {
      link,
      tag,
      transparent,
      outline,
      dark,
      className
    },
    {
      fit: true,
      className: styles['create-button__overlay'],
      scrollable: false,
      modalClass: styles['create-button__modal'],
      closeButton: false
    }
  );

  return (
    <CreateAListFormWithOverlay onCreate={handleCreate} showCancelbtn>
      {text}
    </CreateAListFormWithOverlay>
  );
};

CreateButtonDesktop.displayName = 'CreateButtonDesktop';

CreateButtonDesktop.dataModel = extend(CreateAListForm);

CreateButtonDesktop.propTypes = {
  className: string,
  dark: bool,
  onCreate: func.isRequired,
  outline: bool,
  text: string,
  link: bool,
  tag: string,
  transparent: bool
};

CreateButtonDesktop.defaultProps = {
  className: null,
  dark: false,
  outline: false,
  text: 'Create a List',
  link: false,
  tag: '',
  transparent: false
};
